import Vue from "vue";

export const appInsights = {
  trackEvent: (...args: Parameters<typeof Vue.$appInsights.trackEvent>) => Vue.$appInsights?.trackEvent(...args)
};
